import React from 'react';
import styled from 'styled-components';
import NewsFeed from '../components/NewsFeed';

const PageContainer = styled.div`
  min-height: 100vh;
  padding-top: 100px; /* Space for header */
  padding-bottom: 50px;
  background-color: #f8f9fa;
`;

const PageTitle = styled.h1`
  text-align: center;
  color: #2E7D32;
  font-size: 3rem;
  margin-bottom: 50px;
  font-weight: 700;
`;

const NewsFeedPage = () => {
  return (
    <PageContainer>
      <PageTitle>Cocoa-Pro News</PageTitle>
      <NewsFeed limit={9} /> {/* Show more posts on the dedicated page */}
    </PageContainer>
  );
};

export default NewsFeedPage;
